export default __webpack_public_path__ + "2effbe592d56f8bce77d3999a79a5708.svg";